import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import { Tabs, Typography } from 'seagull';
import { useStore } from '~/contexts';
import { paymentMethodModel, relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import TabPimple from '../TabPimple/TabPimple';
import styles from './AgreementMinisiteTopBar.module.scss';
const testPrefix = 'agreement-minisite-topbar-';
export default function AgreementMinisiteTopBar(param) {
    let { relationship, tabs } = param;
    const isVendorInRelationship = useStore(selectors.user.isVendorInRelationship(relationship));
    const history = useHistory();
    const selectedTabValue = location.pathname.split('/').slice(-1)[0];
    const tabPimples = {
        billingHub: relationshipModel.numPendingCharges(relationship),
        agreement: relationshipModel.numAmendments(relationship),
        paymentMethods: !!relationship.paymentMethod && paymentMethodModel.verificationIncomplete(relationship.paymentMethod) ? 1 : 0,
        invoices: relationshipModel.numPendingInvoices(relationship),
        activity: 0
    };
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.topBarV2, 'hide-on-print'),
        children: !relationshipModel.isPending(relationship) && /*#__PURE__*/ _jsx(Tabs, {
            testId: testPrefix,
            bi: {
                name: 'agreement_minisite_tabs'
            },
            value: selectedTabValue,
            tabs: Object.entries(tabs).map((param)=>{
                let [tabName, { url, label, supportsSample }] = param;
                return {
                    id: url,
                    value: url,
                    component: /*#__PURE__*/ _jsxs("div", {
                        className: styles.tabV2,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                children: label
                            }),
                            !isVendorInRelationship && /*#__PURE__*/ _jsx(TabPimple, {
                                className: styles.pimple,
                                count: tabPimples[tabName]
                            })
                        ]
                    }, tabName),
                    disabled: relationship.isSample && !supportsSample,
                    testId: "".concat(testPrefix, "tab-").concat(tabName.toLowerCase())
                };
            }),
            onChange: (_, value)=>{
                if (selectedTabValue !== value) {
                    history.replace(value);
                }
            }
        })
    });
}
